import { useCallback } from "react";
import { FEATURE_FLAGS } from "../contexts/FeatureFlagsProvider";
import { formatPersonFullName } from "../utils/formatters";
import { useFeatureFlag } from "./useOpenFeatureFlag";

/** Whether the department shows names as "Last First" (`name_format_last_first`). */
export const useLastNameFirst = (): boolean => useFeatureFlag(FEATURE_FLAGS.NameFormatLastFirst);

/** Formats any `{ firstName, lastName }` (nurse, report row, admin user…) per the department's name-order flag. */
export const useFormatPersonName = (): ((person: { firstName: string; lastName: string }) => string) => {
	const lastNameFirst = useLastNameFirst();
	return useCallback((person) => formatPersonFullName(person, lastNameFirst), [lastNameFirst]);
};
